import axios from "@/axios";
import endpoints from "@/endpoints.js";
import ProfileService from "@/services/profile";
const { VUE_APP_API } = process.env;

const state = {
    profile: {},
    fullProfile: null,
    allProfiles : {},
    owners: {},
    selectedProfile: {},
    primaryPatient: {}
};

const mutations = {
    setProfile(state, profileData) {
        state.profile = profileData;
    },
    setAllProfiles(state, profiles) {
        state.allProfiles = profiles;
    },
    SET_FULL_PROFILE(state, profile) {
        state.fullProfile = profile;
    },
    setOwners(state, allOwners) {
        state.owners = allOwners;
    },
    setSelectedProfile(state, profile) {
        state.selectedProfile = profile;
    },
    setPrimaryPatient(state, patient) {
        state.primaryPatient = patient;
    }
};

const actions = {
    async fetchProfile({ commit }) {
        try {
            // Make an API request to fetch profile data
            const response = await axios.get(endpoints.profile); // Replace '/profile' with your actual API endpoint
            const profileData = response.data;

            // Commit the profile data to the state
            commit("setProfile", profileData);
        } catch (error) {
            console.error("Error fetching profile:", error);
            // Optionally handle error cases here
        }
    },
    async fetchAllProfiles({ commit }) {
        try {
            const response = await axios.get(endpoints.profiles);
            const profiles = response.data;
            commit("setAllProfiles", profiles);
        } catch (error) {
            console.error("Error fetching profile:", error);
        }
    },
    async fetchAllOwners({ commit }) {
        try {
            // Make an API request to fetch profile data
            await ProfileService.getProfiles().then(allProfiles => {
                const ownersList = Object.values(allProfiles)
                    .filter(entry => entry.permission?.type === "OWNER")
                    .map(entry => ({
                        name: entry.profile?.name || "Unknown",
                        barcode: entry.profile?.barcode || "N/A",
                        type: entry.permission.type,
                    }));
                commit("setOwners", ownersList);
            })
        } catch (error) {
            console.error("Error fetching multiple profiles:", error);
            // Optionally handle error cases here
        }
    },
    async setSelectedProfile({ commit }, barcode) {
        try {
            await ProfileService.getFullProfile(barcode).then(fullProfile => {
                commit("setSelectedProfile", fullProfile.profile);
            })
        } catch (error) {
            console.error("Error fetching profile:", error);
            // Optionally handle error cases here
        }
    },
    async fetchPrimaryPatient({ commit }, uuid) {
        try {
            // Make an API request to fetch profile data
            const response = await axios.request({
                url: `${VUE_APP_API}/health`,
                data: {
                    path: `/patients/${uuid}`,
                    method: "GET",
                },
                method: "post",
                headers: {
                    authorization: `Bearer ${localStorage.getItem("access_token")}`,
                },
            });
            // Commit the profile data to the state
            commit("setPrimaryPatient", response.data);
        } catch (error) {
            console.error("Error fetching profile:", error);
            // Optionally handle error cases here
        }
    },
    async GET_FULL_PROFILE({ commit }, barcode) {
        commit("SET_FULL_PROFILE", await ProfileService.getFullProfile(barcode));
    },
};

const getters = {
    profile: (state) => state.profile,
    allProfiles : (state) => state.allProfiles,
    fullProfile: state => state.fullProfile,
    owners: (state) => state.owners,
    barcode: (state) => state.profile.profile.barcode,
    selectedProfile: (state) => state.selectedProfile,
    primaryPatient: (state) => state.primaryPatient,
    firstName: (state) => state.profile.profile.name ? state.profile.profile.name.split(" ")[0] : "",
};

export default {
    state,
    mutations,
    actions,
    getters,
};
